import ArticlesLayout from './ArticlesLayout';

export default ArticlesLayout;
